// @flow

export const isPowerOfTwo = (value: number) =>
  ( value & ( value - 1 ) ) === 0 && value !== 0

export const floorPowerOfTwo = (value: number) =>
  Math.pow( 2, Math.floor( Math.log( value ) / Math.LN2 ) )


// WEBPACK FOOTER //
// ./src/utils/mathUtils.js